import { memoryStore, useStore } from "../../../lib/store";
import { type RefObject, useLayoutEffect, useRef } from "react";

// Memorizes scroll position based on the URL path.
// Just add the hook and call the getters/setters when needed.
// Pass a scrollRef when the scroll container is a div (e.g. ScrollableLayout),
// not the window.

const pageScrollStore = memoryStore<Record<string, number>>({});

export function usePageScroll(scrollRef?: RefObject<HTMLElement | null>) {
  const [pageScroll, setPageScroll] = useStore(pageScrollStore);
  const hasRestored = useRef(false);

  // Auto-restore scroll position before paint on mount.
  // Only runs once and only when a scrollRef is provided.
  useLayoutEffect(() => {
    if (hasRestored.current || !scrollRef?.current) return;
    const top = pageScroll[globalThis.location.pathname] ?? 0;
    if (top > 0) {
      scrollRef.current.scrollTop = top;
      hasRestored.current = true;
    }
  });

  return {
    pageScrollY: pageScroll[globalThis.location.pathname] ?? 0,
    setPageScrollY: (value: number) => {
      setPageScroll((prevState) => ({
        ...prevState,
        [globalThis.location.pathname]: value,
      }));
    },
    restorePageScrollY: () => {
      const top = pageScroll[globalThis.location.pathname] ?? 0;
      if (scrollRef?.current) {
        scrollRef.current.scrollTop = top;
      } else {
        scrollTo({ top });
      }
    },
    savePageScrollY: (value?: number) => {
      const scrollY = value ?? scrollRef?.current?.scrollTop ?? window.scrollY;
      setPageScroll((prevState) => ({
        ...prevState,
        [globalThis.location.pathname]: scrollY,
      }));
    },
  };
}
